import { gql } from '@apollo/client'
import { Button } from 'reactstrap'
import { QUERY_COPY_SEARCH } from '../graphql'
import { publishEvent, getTenant } from '../utils'
import SearchButton from '../components/SearchButton/SearchButton'

const COPY_SEARCH = gql(QUERY_COPY_SEARCH)
async function copySearch(searchId) {
  const results = await window.apolloClient.query({ query: COPY_SEARCH, variables: { id: searchId } })
  console.log(results)
  publishEvent('REFRESH SEARCH RESULTS', {}, 'ce2.copySearch')
}

const ce2 = {
  query_execute_hook: function query_execute_hook(documentId, queryDetailId, data) {
    console.log('query_execute_hook',documentId, queryDetailId, data)
    return <SearchButton searchId={documentId} />
  },
  query_copy_hook: function query_copy_hook(documentId, queryDetailId, data) {
    return <Button data-cy={`search-results-copy-button-${documentId}`} size="sm" onClick={async () => copySearch(documentId)}>Copy</Button>
  },
  doc_type_create_hook: function doc_type_create_hook(documentId, queryDetailId, data, location) {
    const tenant = getTenant()
    return <Button size="sm" onClick={() => window.location.href = `${window.location.origin}/${tenant}/create/${documentId}?source=${location.pathname}${location.search}`}>Create</Button>
  },
  doc_type_sql_hook: function doc_type_sql_hook(documentId, queryDetailId, data) {
    const tenant = getTenant()
    return <Button size="sm" onClick={() => window.location.href = `${window.location.origin}/${tenant}/objectTypeSQL?objectTypeId=${documentId}`}>SQL</Button>
  }
}

export default ce2
